var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2018_6974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2018_6974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 13.3334C8.70833 13.3334 8.31597 13.1702 7.98958 12.8438C7.66319 12.5174 7.5 12.1251 7.5 11.6667C7.5 11.2084 7.66319 10.8161 7.98958 10.4897C8.31597 10.1633 8.70833 10.0001 9.16667 10.0001C9.32639 10.0001 9.47396 10.0192 9.60938 10.0574C9.74479 10.0956 9.875 10.1529 10 10.2292V6.66675H12.5V8.33341H10.8333V11.6667C10.8333 12.1251 10.6701 12.5174 10.3438 12.8438C10.0174 13.1702 9.625 13.3334 9.16667 13.3334Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46295 15.8334C5.10647 15.8334 4.8013 15.7065 4.54744 15.4526C4.29359 15.1988 4.16666 14.8936 4.16666 14.5371V5.46304C4.16666 5.10656 4.29359 4.80139 4.54744 4.54754C4.8013 4.29368 5.10647 4.16675 5.46295 4.16675H14.537C14.8935 4.16675 15.1987 4.29368 15.4525 4.54754C15.7064 4.80139 15.8333 5.10656 15.8333 5.46304V14.5371C15.8333 14.8936 15.7064 15.1988 15.4525 15.4526C15.1987 15.7065 14.8935 15.8334 14.537 15.8334H5.46295ZM5.46295 14.5371H14.537V5.46304H5.46295V14.5371Z",
    fill: "#334155"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.ad7dd4181741f4bf93be7b9400fd4d54.svg";
export { ForwardRef as ReactComponent };